import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import {
  provideMobiUiIconBundleSupport,
  provideMobiUiIllustrationCdnSupport,
} from '@mobi/rwc-ui-components-ng-jslib';
import {
  provideClientHydration,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import {
  provideRouter,
  withInMemoryScrolling,
  withRouterConfig,
  withViewTransitions,
} from '@angular/router';
import { routes } from '@app/app.routes';
import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { PlatformContextService } from '@app/services/platform-context.service';
import { environment } from '@src/environments/environment';

export const appCommonConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withViewTransitions({
        skipInitialTransition: true,
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withRouterConfig({
        onSameUrlNavigation: 'ignore',
      })
    ),
    provideClientHydration(
      withHttpTransferCacheOptions({
        includeHeaders: ['content-type'],
      })
    ),
    provideHttpClient(),
    provideMobiUiIconBundleSupport(),
    provideMobiUiIllustrationCdnSupport(),
    {
      provide: IMAGE_LOADER,
      useFactory: (platformContext: PlatformContextService) => {
        return (config: ImageLoaderConfig) => {
          const src = config.src || '';

          // Only process relative paths; keep absolute/data/blob URLs untouched.
          const isAbsoluteUrl = /^(?:[a-z][a-z\d+\-.]*:|\/\/)/i.test(src);
          if (isAbsoluteUrl) {
            return src;
          }

          const platformRokkaUrl = platformContext.getPlatformValue(environment.rokkaUrl);
          const rokkaOrigin = new URL(platformRokkaUrl).origin;
          const normalizedSrc = src.startsWith('/') ? src.slice(1) : src;
          const processedSrc = config.width
            ? normalizedSrc.replace('/noop/', `/resize-width-${config.width}/`)
            : normalizedSrc;

          return `${rokkaOrigin}/${processedSrc}`;
        };
      },
      deps: [PlatformContextService],
    },
  ],
};
